var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36584 0.480418C6.59767 0.280096 6.93979 0.46016 6.93979 0.784276L6.93979 11.5364C6.93979 11.8582 6.59992 12.0383 6.36584 11.8402L0.13336 6.46305C-0.0444534 6.30775 -0.0444534 6.01064 0.13336 5.85759L6.36584 0.480418ZM10.9665 0.318359L12.8121 0.318359L12.8121 12H10.9665L10.9665 0.318359Z",
    fill: "#1F3DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e78496560cd322b2fe305519fa295295.svg";
export { ForwardRef as ReactComponent };